import { Card } from '../components/ui'
import { Award, Medal, Trophy } from 'lucide-react'

export function Podium({ topThree }) {
  return (
    <div className="grid grid-cols-3 gap-2 items-end">
      {topThree[1] ? (
        <Card className="p-2.5 bg-card text-center">
          <div className="w-12 h-12 bg-gray-400 rounded-full flex items-center justify-center mx-auto mb-1">
            <Medal className="h-6 w-6 text-white" />
          </div>
          <div className="text-4xl font-hand mb-0.5">2</div>
          <div className="text-lg font-medium truncate leading-tight">{topThree[1].name}</div>
        </Card>
      ) : (
        <div />
      )}
      {topThree[0] ? (
        <Card className="p-3 bg-gradient-to-b from-yellow-400 to-yellow-500 text-white text-center shadow-paper relative">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-1">
            <Trophy className="h-8 w-8 text-yellow-500" />
          </div>
          <div className="text-5xl font-hand mb-0.5">1</div>
          <div className="text-lg font-medium truncate leading-tight">{topThree[0].name}</div>
        </Card>
      ) : (
        <div />
      )}
      {topThree[2] ? (
        <Card className="p-2.5 bg-card text-center">
          <div className="w-12 h-12 bg-orange-700 rounded-full flex items-center justify-center mx-auto mb-1">
            <Award className="h-6 w-6 text-white" />
          </div>
          <div className="text-4xl font-hand mb-0.5">3</div>
          <div className="text-lg font-medium truncate leading-tight">{topThree[2].name}</div>
        </Card>
      ) : (
        <div />
      )}
    </div>
  )
}